import React, { Component, Fragment } from 'react';
import Navbar from './Navbar';
import Banner from './Banner';
import { withApollo } from 'react-apollo';
import gql from 'graphql-tag';
import { Link, Redirect } from 'react-router-dom';
import AgnosticBannerDesktop from './AgnosticBannerDesktop';
import NycBanner from './NycBanner';
import GeneralFooter from './GeneralFooter';
import Cookies from 'js-cookie';
import MobileDetect from 'mobile-detect';

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bannerOpen: false,
      showAppBanner: false,
      showAgnosticBanner: false
    };
  }

  componentDidMount() {
    if (this.props.loggedIn) {
      this.props.loadData();
      this.props.retrieveProfile();

      if (
        [
          'operating',
          'negative_balance',
          'closed',
          'blacklisted',
          'pending_reactivation',
          'weekly_lease'
        ].includes(this.props.status) &&
        !['/dfaq', '/rls'].includes(this.props.history.location.pathname)
      ) {
        this.props.history.push('/logout');
      } else {
        this.checkStatus();
      }
    }
  }

  checkStatus = async () => {
    const { client, history, status } = this.props;
    const { data } = await client.query({
      query: CHECK_VERIFICATION
    });

    if (data.currentUser) {
      console.log(data.currentUser);
      if (
        data.currentUser.smsVerified &&
        [
          'operating',
          'negative_balance',
          'closed',
          'blacklisted',
          'pending_reactivation',
          'weekly_lease'
        ].includes(data.currentUser.status) &&
        !['/dfaq', '/rls'].includes(this.props.history.location.pathname)
      ) {
        history.push('/logout');
      }
    }
  };

  closeBanner = () => {
    this.setState({ bannerOpen: false });
  };

  closeAppBanner = () => {
    Cookies.set('hide_app', 'true');
    this.setState({ showAppBanner: false });
  };

  closeAgnosticBanner = () => {
    Cookies.set('hide_agnostic', 'true');
    this.setState({ showAgnosticBanner: false });
  };

  isLocatedAt = paths => paths.includes(this.props.location.pathname);

  render() {
    const {
      children,
      location,
      openDialog,
      current_payout_eligible,
      loggedIn,
      status,
      operatingCity,
      has_future_bookings
    } = this.props;
    const { bannerOpen, showAppBanner, showAgnosticBanner } = this.state;
    const hideCookie = Boolean(Cookies.get('hide_app'));
    const hideAgnostic = Boolean(Cookies.get('hide_agnostic'));
    const md = new MobileDetect(window.navigator.userAgent);
    const detectedOs = md.os();
    const detectedPhone = md.phone();
    const showMobileAppBanner =
      loggedIn &&
      !hideCookie &&
      showAppBanner &&
      detectedOs &&
      detectedPhone &&
      ['iOS', 'AndroidOS'].includes(detectedOs) &&
      !this.isLocatedAt(['/apply', 'applyMobile']);
    const agnostic =
      loggedIn &&
      operatingCity === 'toronto' &&
      !hideAgnostic &&
      showAgnosticBanner &&
      !this.isLocatedAt(['/apply', '/applyMobile']);

    // if (loggedIn) {
    //   this.checkVerified();
    // }

    return (
      <Fragment>
        {this.props.location.pathname === '/downloadapp' ||
        this.props.location.pathname === '/loginapp' ||
        this.props.location.pathname.includes('Mobile') ? null : (
          <Navbar
            {...this.props}
            agnostic={agnostic}
            showMobileAppBanner={showMobileAppBanner}
            closeAppBanner={this.closeAppBanner}
            closeAgnosticBanner={this.closeAgnosticBanner}
            detectedOs={detectedOs}
          />
        )}
        {agnostic && window.innerWidth >= 768 ? (
          <AgnosticBannerDesktop closeBanner={this.closeAgnosticBanner} />
        ) : null}
        <div
          className={`body ${
            showMobileAppBanner &&
            !this.props.location.pathname.includes('Mobile')
              ? 'large-padding'
              : ''
          }`}
          style={
            this.props.location.pathname === '/downloadapp' ||
            this.props.location.pathname === '/loginapp' ||
            this.props.location.pathname.includes('Mobile')
              ? { paddingTop: '0' }
              : null
          }>
          {children}
        </div>
        {bannerOpen &&
        current_payout_eligible &&
        this.isLocatedAt(['/dashboard', '/book', '/myearnings']) ? (
          <Banner closeBanner={this.closeBanner} />
        ) : null}
        {bannerOpen &&
        status === 'operating' &&
        operatingCity === 'new_york' &&
        (this.isLocatedAt(['/book']) ||
          (this.isLocatedAt(['/dashboard']) && has_future_bookings)) ? (
          <NycBanner closeBanner={this.closeBanner} />
        ) : null}
        {/* {this.isLocatedAt(['/', '/faq', '/plus', '/pro', '/privacy']) ? (
          <Footer openDialog={openDialog} pathname={location.pathname} />
        ) : null} */}
        {/* <GeneralFooter /> */}
      </Fragment>
    );
  }
}
export default withApollo(Layout);

const CHECK_VERIFICATION = gql`
  {
    currentUser {
      id
      smsVerified
      mobile
      status
    }
  }
`;

// ![
//        '/verify',
//        '/loginapp',
//        '/apply',
//        '/login',
//        '/dashboard',
//        '/profile',
//        '/logout',
//        '/404'
//      ].includes(history.location.pathname)



// WEBPACK FOOTER //
// ./src/components/Layout/index.js